<template>
  <el-menu
    router
    :default-active="activeMenu"
    :unique-opened="true"
    :collapse="collapse"
  >
    <div v-for="(item, index) in Menu" :key="index">
      <el-submenu :index="item.code" v-if="item.kind == '1'">
        <template slot="title">
          <i :class="item.icon || 'ri-settings-4-fill'"></i>
          <span>{{ item.title }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item
            v-for="child in item.children"
            :key="child.code"
            :index="child.code"
            :route="{ name: child.code }"
            >{{ child.title }}</el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item
        v-if="item.kind == '2'"
        :index="item.code"
        :route="{ name: item.code }"
      >
        <i :class="item.icon || 'el-icon-setting'"></i>
        <span slot="title">{{ item.title }}</span>
      </el-menu-item>
    </div>
  </el-menu>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    Menu() {
      return this.$store.state.Menu;
    },
    activeMenu() {
      return this.$route.name == "Home" ? "" : this.$route.name;
    },
    collapse() {
      return this.$store.state.IsCollapse;
    },
  },
  methods: {},
};
</script>

